import { effects } from 'redux-saga'

import setRealm from './setRealm'

export default function* handleMspOfferSelect() {
  const state = yield effects.select()
  const signup = state.signupEdit.get('edit')

  if (!signup.partner) {
    return
  }

  yield effects.call(setRealm)
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/handleMspOfferSelect.js